import { render, staticRenderFns } from "./NtapsPrintLabel.vue?vue&type=template&id=34c92b26&"
import script from "./NtapsPrintLabel.vue?vue&type=script&lang=js&"
export * from "./NtapsPrintLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports